import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getProducts } from '../../api/products';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings } from '../../AppContainer';
import type { ProductsQueryParams } from '../../api/shared/types';

export const productsQueryKey = ['products'] as const;

export function useProducts(params?: ProductsQueryParams) {
  const { apiUrl } = useProductSettings<Settings>();
  return useQuery({
    queryKey: [...productsQueryKey, params],
    queryFn: () => getProducts(apiUrl, params),
    select: (data) => data.items,
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
}
